import type { JSX, ReactNode } from 'react';
import React from 'react';

import { RealtimeProvider } from '@feathr/hooks';

import { DonationToasts } from '../DonationToasts';
import { useDonationRealtimeTransport } from '../hooks';

interface IProps {
  children: ReactNode;
}

/**
 * Wraps children with RealtimeProvider for donation events.
 *
 * This component requires account context and should only be rendered
 * after the account has loaded.
 */
function RealtimeWrapper({ children }: Readonly<IProps>): JSX.Element {
  const transport = useDonationRealtimeTransport();

  return (
    <RealtimeProvider transport={transport}>
      <DonationToasts />
      {children}
    </RealtimeProvider>
  );
}

export default RealtimeWrapper;
